const PrelemComponentContainer = ({
  prelemComponent: PrelemComponent,
  content,
  analytics,
  authoringHelper,
  secondaryArgs,
  prelemId,
}) => {
  return (
    <PrelemComponent
      content={content}
      analytics={analytics}
      authoringHelper={{ ...authoringHelper, prelemId: prelemId }}
      secondaryArgs={secondaryArgs}
    />
  );
};
export default PrelemComponentContainer;
